import { delay } from '@superbet-group/web.lib.utilities';

export async function ensureMinimumDurationForSlowProcess<T>(
    fn: () => Promise<T>,
    showLoadingStateAfterMs: number,
    showLoadingStateMinMs: number,
): Promise<T> {
    let hasRequestEnteredLongLoadingState = false;
    const startMs = new Date().getTime();

    // eslint-disable-next-line promise/always-return, promise/catch-or-return
    delay(showLoadingStateAfterMs).then(() => {
        hasRequestEnteredLongLoadingState = true;
    });

    const result = await fn();

    // Branch where the request has finished before our timer! We can just return now
    if (!hasRequestEnteredLongLoadingState) {
        return result;
    }

    // Since the loader must be shown in this branch, ensure that it's shown
    // for at least the minimum amount of time, minus the time we've already spent waiting
    const timeSpentWaiting = new Date().getTime() - startMs;
    const waitingTime = Math.max(showLoadingStateMinMs - timeSpentWaiting, 0);

    await delay(waitingTime);

    return result;
}
